module.exports = __webpack_public_path__ + "static/media/Megan-Chick.ad76f355.jpg";